import {LayoutFieldModel,
        FieldModel} from '../models/models';

export const validateEmailField = ((email: string) => {
  //validate if email as string follows regex pattern
  const emailRegex = /^(?!.*\.\.)[a-zA-Z0-9][a-zA-Z0-9._%+-]*[a-zA-Z0-9]@[a-zA-Z0-9-]+\.[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$|^(?!.*\.\.)[a-zA-Z0-9][a-zA-Z0-9._%+-]*[a-zA-Z0-9]@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}/;
  const isValidEmail = emailRegex.test(email);
  if(isValidEmail === false) return false;

  //check for spaces, commas, umlaute
  const specialRegex = /[\s,äöüÄÖÜ]/;
  const hasSpecialCharacters = specialRegex.test(email);
  if(hasSpecialCharacters === true) return false;

  return true

  })


export const validatePhoneField = ((phone: string) => {
  //validate if phone as string follows regex pattern
//  const phoneRegex = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{1,4}\)?[-.\s]?)?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,4}$/;
//  const phoneRegex = /^\+?[\d\s\-().]{3,20}$/;
  const phoneRegex = /^\+?[0-9\-\s\(\)]+$/;
  return phoneRegex.test(phone);

})


export const validateUrlField = ((url: string) => {
  //validate url field
  //for now, allow any string
  return true

})


export const getPasswordScore = ((password: string) => {
  const lowerCase = /[a-z]/;
  const upperCase = /[A-Z]/;
  const numbers = /[0-9]/;
  const special = /[\!\§\%\&\(\)\[\]\{\}\?\:\;\_\-\<\>\+\*\#\,]/;

  if(password.length === 0) return {score: 0, backgroundColor: "transparent", text: "Please provide a password"}
  if(password.length < 6) return {score: 25, backgroundColor: "red", text: "Weak"}
  if(password.match(lowerCase) && password.match(upperCase) && password.match(numbers) && password.match(special)){
    return {score: 100, backgroundColor: "green", text: "Very Strong"}
  }
  if((password.match(lowerCase) && password.match(upperCase) && password.match(numbers)) ||
     (password.match(lowerCase) && password.match(upperCase) && password.match(special))){
    return {score: 75, backgroundColor: "blue", text: "Strong"}
  }
  if((password.match(lowerCase) && password.match(upperCase)) ||
     (password.match(lowerCase) && password.match(numbers)) ||
     (password.match(lowerCase) && password.match(special)) ||
     (password.match(upperCase) && password.match(numbers)) ||
     (password.match(upperCase) && password.match(special)) ||
     (password.match(numbers) && password.match(special))){
       return {score: 50, backgroundColor: "orange", text: "Fair"}
  }
  return {score: 25, backgroundColor: "red", text: "Weak"}

  })


export const checkLayoutFieldRequirement = (layoutField: LayoutFieldModel) => {
  //return true if layout field is required
  return layoutField.ReferencedField_sys.Required_sys || layoutField.AccessSetting_sys === 'required';
}

export const getFieldError = (thisField: FieldModel, thisLayoutField: LayoutFieldModel) => {
  const required = checkLayoutFieldRequirement(thisLayoutField);

  //check if field is required
  if(required === true &&
     (thisField.fieldType==="CharField" ||
      thisField.fieldType==='EmailField' ||
      thisField.fieldType==='PhoneField' ||
      thisField.fieldType==='URLField') &&
     (!thisField.fieldValue ||
       thisField.fieldValue === "\"\"")){
       return true
     }
  else if(required === true &&
          thisField.fieldType==="ForeignKey" &&
          !thisField.fieldValue){
       return true
     }
  else if(required === true &&
          thisField.fieldType==="BooleanField" &&
          (thisField.fieldValue === true ||
           thisField.fieldValue === false)){
       return false
     }
  else if(required === true &&
          thisField.fieldType==='IntegerField' &&
          thisField.fieldValue !== null &&
          thisField.fieldValue !== undefined){
    //
    return false
  }
  else if(required === true &&
          thisField.fieldType==='DecimalField' &&
          thisField.fieldValue !== null &&
          thisField.fieldValue !== undefined){
    return false
  }
  else if(required === true &&
          !thisField.fieldValue){
    //
    return true
  }

  //validate email
  if(thisField.fieldType ==='EmailField' && thisField.fieldValue && thisField.fieldValue !== "\"\""){
    const isValid = validateEmailField(thisField.fieldValue)
    return !isValid
  }

  //validate phone
  if(thisField.fieldType ==='PhoneField' && thisField.fieldValue && thisField.fieldValue !== "\"\""){
    const isValid = validatePhoneField(thisField.fieldValue)
    return !isValid
  }

  //validate url
  if(thisField.fieldType ==='URLField' && thisField.fieldValue && thisField.fieldValue !== "\"\""){
    const isValid = validateUrlField(thisField.fieldValue)
    return !isValid
  }


  return false

}
